import { useFeatureFlag } from '~/features/feature-flags/useFeatureFlag';
import { b2bSideCopy, type ListingSide } from '../../b2bSideCopy';
import type { B2BResponseProvider, B2BViewerRole } from '../types';
import { b2bSideForViewerRole } from '../utils';
import { ResponseProviderCards } from './ResponseProviderCards';

type Props = {
  responseId: number;
  providers: B2BResponseProvider[];
  responseUnmasked: boolean;
  listingSide?: ListingSide | null;
  viewerRole?: B2BViewerRole | null;
};

// [MCV-1889] The panel always lists the supplier's providers, so it follows the supplier: the
// buyer of an offered roster reads the seller's providers here, and a seller with none attached yet
// is told so instead of seeing "Providers (0)".
export const ResponseProvidersSection = ({
  responseId,
  providers,
  responseUnmasked,
  listingSide,
  viewerRole,
}: Props) => {
  // The provider page links back to the Responses tab this response lives under; with the flag off
  // there are no tabs and the link stays what it was.
  const side = useFeatureFlag('b2bOfferingListings') ? b2bSideForViewerRole(viewerRole) : undefined;
  const emptyRosterNote = b2bSideCopy(listingSide).emptyRosterNote;
  if (providers.length === 0 && emptyRosterNote && viewerRole === 'BUYER') {
    return (
      <p
        data-cy="response-providers-empty"
        className="rounded-lg border border-dashed border-grey-800 px-4 py-3 text-center text-sm text-content-tertiary"
      >
        {emptyRosterNote}
      </p>
    );
  }
  return (
    <>
      <h3 className="sub-heading-sb mb-3 text-content-primary">Providers ({providers.length})</h3>
      <ResponseProviderCards
        responseId={responseId}
        providers={providers}
        responseUnmasked={responseUnmasked}
        side={side}
      />
    </>
  );
};
